import React from 'react'
import { styled } from '@mui/material/styles'

export interface CounterBadgeProps {
  number: number;
  max: number;
  className?: string;
}

const Badge = styled('div')({
  display: 'inline-block',
  lineHeight: '14px',
  height: '14px',
  padding: '0px 4px',
  fontSize: '10px',
  borderRadius: '25px',
  textAlign: 'center',
  color: '#fff',
  backgroundColor: '#FF665D',
})

const CounterBadge: React.FC<CounterBadgeProps> = (props) => {
  const { number, max, className } = props

  return (
    number > 0 && (
      <Badge className={className}>
        {max ? (number > max ? `${max  }+` : number) : number}
      </Badge>
    )
  )
}

export default CounterBadge
